// extracted by mini-css-extract-plugin
export default {"dateSection":"dateSlide_dateSection__KrVlw","date":"dateSlide_date__AJg4N","price":"dateSlide_price__KeMOU","calenderIcon":"dateSlide_calenderIcon__iqmiq"};